<template>
	<v-dialog v-model="organizationNamesDialog" max-width="500">
		<v-card>
			<v-card-title class="headline">Nazwa podmiotu już istnieje w systemie</v-card-title>

			<v-card-text>Podana nazwa podmiotu została już zarejestrowana w systemie.</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="green darken-1"
					flat="flat"
					@click="$emit('close')">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "OrganizationWithThisNameExistsDialog",

		props: {
			organizationNamesDialog: {},
		},
	};
</script>

<style scoped>

</style>